<template>
  <div class="">

    <div id="breadcrumb" class="m-1">
    <b-breadcrumb >
    	<b-breadcrumb-item text="Home" href="#/"/>
    	<b-breadcrumb-item text="Calculators" active/>
    </b-breadcrumb>
    </div>


    <b-col id=content sm=12 lg="8" offset-lg="2">
    <h1>Cryptocurrency Calculators</h1>
    <div class="information text-left">
    	<p>Our calculators can help you figure out all kinds of crytpo pricing information.</p>
    	<p>The Bitcoin calculator is a <strong>two-currency calculator</strong>. Use it to figure pricing of one currency to another. Examples: Bitcoin to US Dollars; or Ethereum to Ripple. How much BCH can I buy with $100 USD?</p>
    	<p>The Altcoin calculator is a <strong>three-currency calculator</strong>. Use it to figure pricing of one currency to another via a third coin. This is how most altcoins are purchased using Bitcoin or Ethereum. Example: Komodo to US Dollars using Ethereum. How much POE can I get for $200 USD worth of ETH?</p>
    	<p>Both cryto calculators support <strong>historical pricing</strong> and <strong>exchange specific pricing</strong>.</p>
    </div>



    <div  >
    <b-card-group deck>


    <b-card header="2-Way Bitcoin Calcuator" href="#/calculators/altcoin" class="mb-2 cursor-pointer" @click="navigate('/calculators/bitcoin')">
      <p class="card-text text-left">
      	<ul>
	        <li>Fiat to Bitcoin price.</li>
	        <li>Bitcoin to altcoin price.</li>
	        <li>Calculate how many crypto coins you can buy for a given amount of money.</li>
	       	<li>Example: How much BTC can I by for $200 USD?</li>
	       	<li>Calculate the price of one currency in terms of another currency.</li>
	       	<li>Example: How much BTC can I by for 20 ETH?</li>
	       	<li>Calculate the price of any crypto currency in the price of another.</li>
	       	<li>Calculate how much a crypto currency is worth today.</li>
	       	<li>Calculate how much a crypto currency was worth in the past?</li>
       	</ul>
      </p>
      <b-list-group flush>
        <b-list-group-item><a href="#/calculators/bitcoin" class="card-link">Bitcoin Calculator</a></b-list-group-item>

    </b-list-group>
    </b-card>

    <b-card header="3-Way Altcoin Calculator" href="#/calculators/altcoin" class="mb-2 cursor-pointer" @click="navigate('/calculators/altcoin')">
	  <div class="card-text text-left">
	  <ul>

     	<li>Fiat to Bitcoin to Altcoin price.</li>
     	<li>Calculate how many crypto coins you can buy for a given amount of money using a intermidary coin.</li>
     	<li>Example: How much XRP can I buy for $100 USD worth of Ethereum?</li>
     	<li>Calculate how much a crypto currency is worth today.</li>
     	<li>Calculate how much a crypto currency was worth in the past?</li>
     </ul>
    </div>
	  </p>
	 <b-list-group flush>
	 <b-list-group-item><a href="#/calculators/altcoin" class="card-link">Altcoin Calculator</a></b-list-group-item>
     </b-list-group>
	</b-card>



    </b-card-group>
    </div>

    </b-col>


  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {
      msg: ''
    }
  },
  methods: {
	  navigate(uri) {
//		  console.log("Navigate:", uri);
		  this.$router.push(uri);
	  }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

a {
  color: #42b983;
}

.information {
	text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Calculators.vue